import ListHistorySpb from "./ListHistorySpb";

export default ListHistorySpb;
